import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import cn from 'classnames/bind';

// Components
import VendorsSidebarPhone from './VendorsSidebarPhone';
import VendorsSidebarDesktop from './VendorsSidebarDesktop';

// Styles
import styles from './styles.styl';

const cx = cn.bind(styles);

function VendorsSidebar({ promos, partners }) {
  const isVerticalTablet = useSelector(state => state.responsive.isVerticalTablet);

  const SidebarComponent = useMemo(
    () => (isVerticalTablet ? VendorsSidebarPhone : VendorsSidebarDesktop),
    [isVerticalTablet],
  );

  return (
    <div className={cx('VendorsSidebar')}>
      <SidebarComponent promos={promos} partners={partners} />
    </div>
  );
}

VendorsSidebar.propTypes = {
  promos: PropTypes.array,
  partners: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

VendorsSidebar.defaultProps = {
  promos: [],
};

export default VendorsSidebar;
